import { render } from "./BoardRectangle.vue?vue&type=template&id=67847ba2&scoped=true"
import script from "./BoardRectangle.vue?vue&type=script&lang=js"
export * from "./BoardRectangle.vue?vue&type=script&lang=js"

import "./BoardRectangle.vue?vue&type=style&index=0&id=67847ba2&scoped=true&lang=css"

import exportComponent from "C:\\Apps\\AppBase\\app-base-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67847ba2"]])

export default __exports__